import { Box, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export function AISetTitle() {
  return (
    <Box
      px="xs"
      style={{
        height: 22,
        background: 'rgba(0, 0, 0, 0.25)',
        borderRadius: 'var(--mantine-radius-xl)',
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      <Text size="textXs" fw={FONT_WEIGHTS.bold} c="white">
        Suggested actions
      </Text>
    </Box>
  );
}
